<template>
    <div>
        <section class="listing-page">
            <div class="section-header text-center pb-2">
                <h2 class="mb-0">Ofertas <span>de vehículos usados</span></h2>
            </div>
            <section class="p-4">
                <div class="row">
                    <!--Side-Bar-->
                    <aside class="col-md-3 col-md-pull-9">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="d-none d-sm-none d-md-block">
                                    <div class="sidebar_widget">
                                        <filtroBusqueda />
                                    </div>
                                </div>
                                <div class="d-block d-sm-block d-md-none">
                                    <b-button
                                        v-b-toggle.sidebar-1
                                        class="mb-2 float-filter"
                                        size="sm"
                                    >
                                        <i
                                            class="fa fa-filter"
                                            aria-hidden="true"
                                        ></i>
                                        Filtros
                                    </b-button>
                                    <b-sidebar id="sidebar-1" shadow>
                                        <div class="p-3">
                                            <filtroBusqueda />
                                        </div>
                                    </b-sidebar>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="sidebar_widget">
                                    <listavehiculosRecientes />
                                </div>
                            </div>
                        </div>
                    </aside>
                    <!--/Side-Bar-->
                    <div class="col-md-9 col-md-push-3">
                        <div class="result-sorting-wrapper">
                            <div class="sorting-count">
                                <p>
                                    1 - {{ Object.keys(inventario).length }}
                                    <span>
                                        de
                                        {{
                                            Object.keys(inventario).length
                                        }}
                                        Resultados para su búsqueda.
                                    </span>
                                </p>
                            </div>
                            <div class="result-sorting-by">
                                <p>Ordenar por:</p>
                                <form>
                                    <div
                                    class="form-group select sorting-select"
                                    >
                                        <select
                                        class="form-control"
                                        @change="orderFilter"
                                        >
                                            <option>Seleccione</option>
                                            <option value="desc">Mayor Precio</option>
                                            <option value="asc">Menor Precio</option>
                                            <option value="recientes">Más Recientes</option>
                                        </select>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <listaInventario />
                    </div>
                </div>
            </section>
        </section>
    </div>
</template>

<script>
import filtroBusqueda from "./frontFiltroBusqueda";
import listaInventario from "./frontInventario";
import listavehiculosRecientes from "./frontListaRecientes";
import { mapFields } from "vuex-map-fields";
import _ from "lodash";
export default {
    components: {
        filtroBusqueda,
        listaInventario,
        listavehiculosRecientes
    },
    props: {
        vehiculos: Object,
        recientes: Array,
        filtros: Object,
        contadores: Object
    },
    computed: {
        ...mapFields("buscador", [
            "inventario",
            "contadoreslocal",
            "recienteslocal",
            "filtroslocal",
            "links"
        ])
    },
    created() {
        this.inventario = this.vehiculos.data;
        this.contadoreslocal = { ...this.contadores };
        const { data, ...links } = this.vehiculos;
        this.links = links;
        this.recienteslocal = this.recientes;
        this.filtroslocal = this.filtros;
    },
    data() {
        return {
            ordenar: null,
            form: {
                search: ''
            }
        };
    },
    methods: {
        forceUpper (e, obj, prop) {
            const start = e.target.selectionStart
            e.target.value = e.target.value.toUpperCase()
            this.$set(obj, prop, e.target.value)
            e.target.setSelectionRange(start, start)
        },
        searchFilter() {
            var listSearch =  _.map(this.inventario, (marca) => {
                return {
                    marca: marca.marca,
                    linea: marca.linea,
                    modelo: marca.modelo,
                    precio: marca.precio,
                    titulo: marca.marca+' '+marca.linea+''+marca.modelo+' '+marca.precio,
                }
            });
            //const a = _.split(listSearch, (bsq) =>  bsq.titulo, ' ');
            const result = _.filter(listSearch, (bsq) =>  bsq.titulo.includes(this.form.search));
            console.log(result)
        },
        orderFilter(e) {
            this.ordenar = e.target.value;
            var params = new URLSearchParams(window.location.search);
            params.set('orden', this.ordenar);
            window.location.href = `${window.location.pathname}?${params}`;
        }
    }
};
</script>

<style lang="scss">
.listing-page {
    overflow: hidden;
    padding: 30px 0;
}
button.btn.mb-2.float-filter.btn-secondary.btn-sm.collapsed {
    position: fixed;
    top: 35%;
    text-align: center;
    z-index: 100;
}
.search-filter {
    border-radius: 20px;
    border: 1px solid #dddddd;
    height: 30px;
    width: 200px;
    font-size: 12px;
    margin-right: 50px;
    text-align: left;
    padding: 0 30px 0 12px;
    outline:none;
}
</style>
